import { PaginationMetaLink } from '../components/Modals/Paginator';

/**
 * Convert WebDB metadata format to Laravel pagination format
 * that the Paginator component expects
 *
 * WebDB format:
 * {
 *   page: 1,
 *   limit: 15,
 *   page_count: 3,
 *   total_count: 45
 * }
 *
 * Laravel format:
 * {
 *   current_page: 1,
 *   from: 1,
 *   to: 15,
 *   total: 45,
 *   last_page: 3,
 *   per_page: 15,
 *   links: [...]
 * }
 */
export const convertWebDBPaginationToLaravel = (metadata: {
  page: number;
  limit: number;
  page_count: number;
  total_count: number;
}): {
  current_page: number;
  from: number;
  to: number;
  total: number;
  last_page: number;
  per_page: number;
  links: PaginationMetaLink[];
} => {
  const {
    page, limit, page_count: pageCount, total_count: totalCount,
  } = metadata;

  // Calculate from and to
  const from = (page - 1) * limit + 1;
  const to = Math.min(page * limit, totalCount);

  // Generate links array
  const links: PaginationMetaLink[] = [];

  // Previous link
  links.push({
    url: page > 1 ? 'prev' : null,
    label: '&laquo; Previous',
    active: false,
  });

  // Page number links
  for (let i = 1; i <= pageCount; i += 1) {
    links.push({
      url: `page=${i}`,
      label: String(i),
      active: i === page,
    });
  }

  // Next link
  links.push({
    url: page < pageCount ? 'next' : null,
    label: 'Next &raquo;',
    active: false,
  });

  return {
    current_page: page,
    from,
    to,
    total: totalCount,
    last_page: pageCount,
    per_page: limit,
    links,
  };
};
